
import React, { memo } from 'react'
import { withStyles } from '@material-ui/core';
import InputMask from 'react-input-mask';
import getObjectValue from 'libs/getObjectValue'

const style = theme => ({
	root: {
	}
})

function MaskedTextInput({
	children,
	formikProps,
	id,
	mask,
}) {
	const value = getObjectValue(id, formikProps.values, '')
	return (
		<InputMask
			mask={mask}
			value={value}
			maskChar={null}
			onBlur
		>
			{() => children}
		</InputMask>
	)
}

export default withStyles(style)(memo(MaskedTextInput, (prevProps, nextProps) => {
	const prevFormikProps = prevProps.formikProps;
	const nextFormikProps = nextProps.formikProps;
	if (JSON.stringify(getObjectValue(prevProps.id, prevFormikProps.values)) !==
		JSON.stringify(getObjectValue(nextProps.id, nextFormikProps.values))
	) return false;
	if (JSON.stringify(getObjectValue(prevProps.id, prevFormikProps.errors)) !==
		JSON.stringify(getObjectValue(nextProps.id, nextFormikProps.errors))
	) return false;
	if (JSON.stringify(getObjectValue(prevProps.id, prevFormikProps.touched)) !==
		JSON.stringify(getObjectValue(nextProps.id, nextFormikProps.touched))
	) return false;
	return true
}))